import axios from 'axios';
import { getToken, getTokenHeader } from '../../../../../screen/auth/action';
import {
    AddBeneficiaryUrl,
    updateBeneficiaryInfoUrl,
    UserFileUploadUrl,
    getBeneficiaryRelationsUrl,
    getBeneficiaryInfoUrl,
    getBenefitTypesUrl,
    getBenefitBeneficiarySummaryUrl,
    deleteBeneficiaryUserUrl,
    deleteBeneficiaryRelationUrl,
    getBeneficiaryUploadedImageUrl,
    GstUserPanDataFetchUrl,
    GetAllUserInsuranceCertificateUrl,
    getAmountForMedicalInsuranceUrl,
    getBenefitsDataOfUserUrl,
    GetUserInsuranceCertificateUrl,
    getNomineeInfoforSelectedBeneficiaryUrl
} from '../url';
import { toast } from 'react-toastify';

export const getBeneficiaryRelations  = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(getBeneficiaryRelationsUrl(), getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const AddBeneficiary = async (data) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(
        `${AddBeneficiaryUrl()}`,
        data,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};
export const getBenefitBeneficiarySummary = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(getBenefitBeneficiarySummaryUrl(), getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getBeneficiaryInfo = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(getBeneficiaryInfoUrl(), getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getNomineeInfo = async (beneficiary_id, benefit_type) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${getNomineeInfoforSelectedBeneficiaryUrl()}?beneficiary_id=${beneficiary_id}&benefit_type=${benefit_type}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const getBeneficiaryUploadedImage = async (beneficiary_id) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(
        `${getBeneficiaryUploadedImageUrl()}/${beneficiary_id}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const deleteBeneficiaryUserAction = async (beneficiary_id) => {
    return new Promise(async (next) => {
      let token = await getToken();
      await axios
        .delete(
          `${deleteBeneficiaryUserUrl()}/${beneficiary_id}`,
          getTokenHeader(token),
        )
        .then(async ({ data }) => {
          return next(data);
        })
        .catch((err) => {
          return next({ error: err });
        });
    });
};
export const deleteBenficiaryRelationAction = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    const headers = getTokenHeader(token);
    await axios
      .delete(
        deleteBeneficiaryRelationUrl(),
        {
          ...headers,
          data 
        },
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const updateBeneficiaryInfoAction = async (data) => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .put(updateBeneficiaryInfoUrl(), data, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const UserFileUploadNow = async (userId, fileType, formData) => {
  return new Promise(async (next) => {
    const token = await getToken();
    await axios
      .post(
        `${UserFileUploadUrl()}?user_id=${userId}&file_type=${fileType}`,
        formData,
        getTokenHeader(token),
      )
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};
export const getBeneficiaryBenefits  = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(getBenefitTypesUrl(), getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const GstUserPanDataFetch = async (pan, checkExists = true) => {
  return new Promise(async (next) => {
    const token = await getToken();

    await axios
      .get(`${GstUserPanDataFetchUrl()}?pan_no=${pan}&check_exists=${checkExists}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};

export const getAmountForMedicalInsurance = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${getAmountForMedicalInsuranceUrl()}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};

export const getBenefitsDataOfUser = async (name) => {
  return new Promise(async (next) => {
    let token = await getToken();

    await axios
      .get(`${getBenefitsDataOfUserUrl()}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return err;
      });
  });
};
export const GetAllUserInsuranceCertificate = async () => {
  return new Promise(async (next) => {
    let token = await getToken();
    await axios
      .get(`${GetAllUserInsuranceCertificateUrl()}`, getTokenHeader(token))
      .then(async ({ data }) => {
        return next(data);
      })
      .catch((err) => {
        return next({ error: err });
      });
  });
};
export const GetInsuranceCertificateAction = async (file_id, file_name) => {
  try {
    let token = await getToken();
    fetch(`${GetUserInsuranceCertificateUrl()}${file_id}`, {
      method: 'GET',
      ...getTokenHeader(token),
    }).then(function (t) {
      return t.blob().then((b) => {
        if (b.type.includes('application/json')) {
          return toast.error('No Certificate Found');
        }
        let a = document.createElement('a');
        a.href = URL.createObjectURL(b);
        a.setAttribute('download', file_name);
        a.click();
      });
    });
  } catch (err) {
    console.log(err);
  }
};